module.exports = __webpack_public_path__ + "img/fi.2eed4de7.jpg";